import currencyFormatting from '../currencyFormatting';
import { getPriceRange } from '../moneyUtils';

import { UseCalcItemPriceProps, UseCalcItemPriceResult } from './types';

/**
 *
 * getSalesPrice is responsible for showing price or price range if have or don't have sales (red color price typically)
 * getOriginalPrice is responsible for show "old price" or refurb price
 *
 */
const useCalcItemPrice = ({
  priceCents,
  salePriceCents,
  newPriceMin,
  newPriceMax,
  newSalePriceMin,
  newSalePriceMax,
  productConditionMax,
  UsedAnyPriceMin,
}: UseCalcItemPriceProps): UseCalcItemPriceResult => {
  const getSalesPrice = () => {
    const salePriceRange = getPriceRange(newSalePriceMin, newSalePriceMax);
    const originalpriceRange = getPriceRange(newPriceMin, newPriceMax);
    if (UsedAnyPriceMin) {
      if (productConditionMax) {
        // if refurbished
        // if (newPriceMin && newSalePriceMin && newPriceMin < newSalePriceMin) {
        //   // 2 SubModels and one is Refurb.
        //   return getPriceRange(newPriceMin, newSalePriceMin);
        // }
        // range price - $400-$500
        if (salePriceRange) {
          return salePriceRange;
        }
        // price - $400
        if (newSalePriceMin) {
          return `$${newSalePriceMin}`;
        }
        if (originalpriceRange) {
          // range price if refurbished - $400-$500
          return originalpriceRange;
        }
        if (newPriceMin) {
          return currencyFormatting(Number(newPriceMin));
        }
        // single price if refurbished
        // unexpected case pls contact java developer
        return currencyFormatting(priceCents / 100);
      }
      if (originalpriceRange) {
        // range price - $400-$500
        return originalpriceRange;
      }

      // corner case for refurbished and no sales
      // ex: Stoeger RX20 S3 Breakbarrel Air Rifle
      if (priceCents && salePriceCents < 0) {
        return currencyFormatting(priceCents / 100);
      }
      // just price - $500
      return currencyFormatting(salePriceCents / 100);
    }
    if (salePriceRange) {
      // range price if sales - $300-$350
      return salePriceRange;
    } else if (salePriceCents > 0) {
      // just price if sales - $500
      return currencyFormatting(salePriceCents / 100);
    } else if (priceCents > 0) {
      if (originalpriceRange) {
        // if no sales and is range
        return originalpriceRange;
      }
      // just a single prcie without sales - $500
      return currencyFormatting(priceCents / 100);
    } else {
      return null;
    }
  };

  const getOriginalPrice = () => {
    if (salePriceCents < 0) {
      return null;
    }
    const priceRange = getPriceRange(newPriceMin, newPriceMax);
    if (priceRange) {
      // if we have sales and this is a price range - $400-$500
      return priceRange;
    } else if (priceCents > 0) {
      // if we have sales and this is a single price - $400
      return currencyFormatting(priceCents / 100);
    } else {
      return null;
    }
  };

  const getProductConditionalPrice = () => {
    // price for product conditional max
    // ex: Refurb. $300
    if (UsedAnyPriceMin) {
      return currencyFormatting(Number(UsedAnyPriceMin));
    }
    return currencyFormatting(salePriceCents / 100);
  };

  return {
    isRefurbished: Boolean(productConditionMax && UsedAnyPriceMin),
    getSalesPrice,
    getOriginalPrice,
    getProductConditionalPrice,
  };
};

export default useCalcItemPrice;
